<template>
    <Teleport to="body">
        <div
            v-if="isOpen"
            class="
                bg-black bg-opacity-25
                fixed
                top-0
                left-0
                w-full
                h-full
                flex
                items-center
                justify-center
            "
            :style="{
                zIndex: zIndex ?? 101,
            }"
            @click.self="$emit('close')"
        >
            <div
                class="
                    bg-white
                    rounded-lg
                    shadow-lg
                    relative
                    font-sans
                    min-w-[90vw]
                    max-w-[90vw]
                    md:min-w-[30vw] md:max-w-[40vw]
                "
            >
                <header
                    class="
                        flex
                        items-center
                        mb-4
                        px-4
                        pt-4
                        pb-2
                        border-b-gray-300 border-b-[1px]
                    "
                    v-if="title"
                >
                    <h3 class="mr-12 font-bold text-[16px]">{{ title }}</h3>
                    <button
                        type="button"
                        class="
                            rounded-md
                            ml-auto
                            leading-[0]
                            p-1
                            hover:bg-gray-100
                        "
                        @click="$emit('close')"
                    >
                        <ion-icon name="close"></ion-icon>
                    </button>
                </header>
                <div class="px-4 pb-4">
                    <slot></slot>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: "ModalCustom",
    props: ["title", "isOpen", "zIndex"],
};
</script>

<style scoped></style>
